import React from 'react';

const LightTransmission = () => {
    return <div>LightTransmission</div>;
};

export default LightTransmission;
